import React, {Component} from 'react';
import PropTypes from "prop-types";

import ControlForm from "../Controls/ControlForm";
import SectionCard from "../Sections/SectionCard";
import SummaryTable from "../Tables/SummaryTable";
import SectionModal from "../Sections/SectionModal";
import ControlExports from "../Controls/ControlExports";

import * as Utils from "../../utilities/utilities";

import {TEXT} from '../../utilities/strings';

/**
 * Component to select items for the summary section, and pass them into the SectionCard
 *
 * @example
 * <SummarySection
 *   loading={this.props.loading}
 *   selectedState={this.props.selectedState}
 *   comparisonState={this.props.comparisonState}
 *   selectedCounty={this.props.selectedCounty}
 *   comparisonCounty={this.props.comparisonCounty}
 *   nationalData={this.props.nationalData}
 *   statesData={this.props.statesData}
 *   countiesData={this.props.countiesData}
 *   summaryType={this.props.summaryType}
 *   displayType={this.props.displayType}
 *   selectedCost={this.props.selectedCost}
 *   selectedStateFips={this.props.selectedStateFips}
 *   comparisonStateFips={this.props.comparisonStateFips}
 *   selectedCountyFips={this.props.selectedCountyFips}
 *   comparisonCountyFips={this.props.comparisonCountyFips}
 *   onExportData={this.props.exportSummaryData}
 *   onUpdateSelections={this.props.setFormSelections}
 *  />
 */
export default class SummaryCard extends Component {

  static propTypes = {
    loading: PropTypes.bool,
    selectedState: PropTypes.object,
    comparisonState: PropTypes.object,
    selectedCounty: PropTypes.object,
    comparisonCounty: PropTypes.object,
    nationalData: PropTypes.array,
    statesData: PropTypes.array,
    countiesData: PropTypes.array,
    summaryType: PropTypes.string,
    displayType: PropTypes.string,
    selectedCost: PropTypes.string,
    selectedStateFips: PropTypes.number,
    comparisonStateFips: PropTypes.number,
    selectedCountyFips: PropTypes.number,
    comparisonCountyFips: PropTypes.number,
    onExportData: PropTypes.func.isRequired,
    onUpdateSelections: PropTypes.func.isRequired
  };

  render() {
    const sectionType = 'summary';

    const showCounty = process.env.REACT_APP_HIDE_COUNTY !== 'true'
    const footnote = Utils.getSectionFootnote(this.props.selectedCost)

    const summary = (
      <div>
        <span>{TEXT.summary_description}</span>
        <SectionModal title={TEXT.state_info_title} body={TEXT.state_info_body}/>
      </div>
    );

    const controls = (
      <ControlForm
        formName={sectionType}
        showSelectedState={true}
        showComparisonState={true}
        showSelectedCounty={showCounty}
        showComparisonCounty={showCounty}
        showSummaryType={true}
        countiesData={this.props.countiesData}
        statesData={this.props.statesData}
        displayType={this.props.displayType}
        summaryType={this.props.summaryType}
        selectedCost={this.props.selectedCost}
        selectedStateFips={this.props.selectedStateFips}
        comparisonStateFips={this.props.comparisonStateFips}
        selectedCountyFips={this.props.selectedCountyFips}
        comparisonCountyFips={this.props.comparisonCountyFips}
        onSubmit={this.props.onUpdateSelections}
      />
    );

    const content = (
      <SummaryTable
        nationalData={this.props.nationalData}
        selectedState={this.props.selectedState}
        comparisonState={this.props.comparisonState}
        selectedCounty={this.props.selectedCounty}
        comparisonCounty={this.props.comparisonCounty}
        summaryType={this.props.summaryType}
      />
    )

    const exports = (
      <ControlExports
        onExportData={this.props.onExportData}
        showImageExports={false}
      />
    )

    /**
     * Using constants above to pass into SectionCard for rendering
     */
    return (
      <SectionCard
        section={sectionType}
        title={TEXT.summary_title}
        exports={exports}
        controls={controls}
        summary={summary}
        content={content}
        footnote={footnote}
      />
    );
  }
}
